import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase } from '@material-ui/core';
import { callPhone } from '../chat/chatLinks';
import tokens from '../theme/tokens';

// 자료를 보여 줄 수 없을 때 — kind: invalid(없음·만료·닫힘) · error(서버 응답 없음) · pending(오더 자료 준비 중) · loading
const useStyles = makeStyles(() => ({
  root: {
    padding: '40px 24px 32px',
    borderRadius: tokens.radiusLg,
    backgroundColor: tokens.surface,
    boxShadow: tokens.cardShadow,
    textAlign: 'center',
  },
  mark: {
    width: 56,
    height: 56,
    margin: '0 auto 16px',
    borderRadius: 28,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.primarySoft,
    color: tokens.primaryDark,
    '& svg': { display: 'block' },
  },
  title: { margin: 0, fontSize: 19, fontWeight: 700, letterSpacing: -0.8, color: tokens.ink, wordBreak: 'keep-all' },
  sub: { margin: '8px 0 0', fontSize: 14, lineHeight: 1.6, letterSpacing: -0.4, color: tokens.text, wordBreak: 'keep-all' },
  btn: {
    marginTop: 22,
    height: 46,
    padding: '0 22px',
    borderRadius: 23,
    backgroundColor: tokens.primary,
    color: tokens.surface,
    fontSize: 15,
    fontWeight: 700,
    letterSpacing: -0.4,
    fontFamily: tokens.font,
  },
  ghost: { backgroundColor: tokens.surface, color: tokens.primaryDark, border: `1px solid ${tokens.primaryLine}` },
  dots: {
    display: 'inline-flex',
    gap: 6,
    '& i': { width: 8, height: 8, borderRadius: 4, backgroundColor: tokens.primary, animation: '$blink 1.2s ease-in-out infinite' },
    '& i:nth-child(2)': { animationDelay: '.2s' },
    '& i:nth-child(3)': { animationDelay: '.4s' },
  },
  '@keyframes blink': { '0%, 80%, 100%': { opacity: 0.25 }, '40%': { opacity: 1 } },
}));

const COPY = {
  invalid: { title: '열 수 없는 링크예요', sub: '주소를 다시 확인하시거나 고객센터로 문의해 주세요.' },
  error: { title: '잠시 후 다시 확인해 주세요', sub: '배송 정보를 불러오지 못했어요.' },
  pending: { title: '배송 정보를 준비하고 있어요', sub: '잠시 후 자동으로 갱신돼요.' },
  loading: { title: '배송 정보를 불러오고 있어요', sub: '' },
};

const Icon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 7l9-4 9 4v10l-9 4-9-4z" /><path d="M3 7l9 4 9-4" /><path d="M12 11v10" />
  </svg>
);

function TrackNotice({ kind, onRetry }) {
  const cs = useStyles();
  const c = COPY[kind] || COPY.error;
  return (
    <section className={cs.root}>
      <div className={cs.mark}>{kind === 'loading' || kind === 'pending' ? <span className={cs.dots}><i /><i /><i /></span> : <Icon />}</div>
      <h1 className={cs.title}>{c.title}</h1>
      {c.sub && <p className={cs.sub}>{c.sub}</p>}
      {kind === 'invalid' && <ButtonBase className={cs.btn} onClick={callPhone} focusRipple={false}>고객센터 전화하기</ButtonBase>}
      {kind === 'error' && onRetry && <ButtonBase className={`${cs.btn} ${cs.ghost}`} onClick={onRetry} focusRipple={false}>다시 확인</ButtonBase>}
    </section>
  );
}

export default TrackNotice;
